import { t } from 'ttag'
import styled from 'styled-components'

import { Text } from '@h2/components/typography/text'
import { Heading } from '@h2/components/typography/heading'
import {
  CheckIcon,
  InterestProfilerIcon,
  SkillsProfilerIcon,
  WorkImportanceProfilerIcon
} from '@h2/components/icons'
import { Flex } from '@h2/components/layout/flex'
import { PB60T, WHITE } from '@h2/components/colors'

const StyledBox = styled.div`
  border: 1px solid ${PB60T};
  background-color: ${WHITE};
  border-radius: 3px;
  min-height: 26px;
  min-width: 26px;
  max-height: 26px;
  max-width: 26px;
`
const ItemText = styled(Text)`
  width: 100%;
  margin: 0;
`
const PreferencesSummary = ({ objectType, preferences }) => {
  const innerContent = () => {
    switch (objectType) {
      case 'cluster':
      case 'onet':
        return (
          <>
            <Flex gap="15px" margin="15px 0" alignItems="center">
              <InterestProfilerIcon />
              <ItemText>{t`Interest Profiler:`} </ItemText>
              <StyledBox>
                {preferences.inInterestProfiler ? <CheckIcon /> : null}
              </StyledBox>
            </Flex>
            <Flex gap="15px" margin="15px 0" alignItems="center">
              <WorkImportanceProfilerIcon />
              <ItemText>{t`Work Importance Profiler:`} </ItemText>
              <StyledBox>
                {preferences.inWorkImportanceProfiler ? <CheckIcon /> : null}
              </StyledBox>
            </Flex>
            <Flex gap="15px" margin="15px 0" alignItems="center">
              <SkillsProfilerIcon />
              <ItemText>{t`Skills Profiler:`} </ItemText>
              <StyledBox>{preferences.inSkillsProfiler ? <CheckIcon /> : null}</StyledBox>
            </Flex>
          </>
        )
      case 'college':
        return (
          <>
            <Flex gap="15px" margin="15px 0" alignItems="center">
              <InterestProfilerIcon />
              <ItemText>{t`Preferred Student Body Size:`}</ItemText>
              <StyledBox>{preferences.inPreferredSizes ? <CheckIcon /> : null}</StyledBox>
            </Flex>
            <Flex gap="15px" margin="15px 0" alignItems="center">
              <WorkImportanceProfilerIcon />
              <ItemText>{t`In Preferred State:`}</ItemText>
              <StyledBox>
                {preferences.inPreferredStates ? <CheckIcon /> : null}
              </StyledBox>
            </Flex>
            <Flex gap="15px" margin="15px 0" alignItems="center">
              <SkillsProfilerIcon />
              <ItemText>{t`In Preferred Setting:`}</ItemText>
              <StyledBox>
                {preferences.inPreferredSetting ? <CheckIcon /> : null}
              </StyledBox>
            </Flex>
          </>
        )
      default:
        return <Text align="center">{`This information is not available`}</Text>
    }
  }

  return (
    <div>
      <Heading level="5">{t`Your Preferences`}</Heading>
      {innerContent()}
    </div>
  )
}

export { PreferencesSummary }
